import { render, staticRenderFns } from "./SetAgentCom.vue?vue&type=template&id=244f3a7c"
import script from "./SetAgentCom.vue?vue&type=script&lang=js"
export * from "./SetAgentCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports